import React from "react"
import TrainingIcon from "@mui/icons-material/School"
import LanguageIcon from "@mui/icons-material/Language"
import ManagerIcon from "@mui/icons-material/Explore"
import OperatorIcon from "@mui/icons-material/Assignment"
import Random from "@mui/icons-material/Star"

import { Grid } from "@mui/material"
import { makeApiCall } from "../../../utils/gatewayUtils"
import apiConfig from "../../../apiConfig"

export type Badge = {
  title: string
  icon: string
  id?: string
}

type BadgesProps = {
  instructorId: string
}

const iconFromString = (iconString: string) => {
  switch (iconString) {
    case "trainingSpecialist":
      return <TrainingIcon />
    case "otherLanguage":
      return <LanguageIcon />
    case "manager":
      return <ManagerIcon />
    case "operator":
      return <OperatorIcon />
    default:
      return <Random />
  }
}

const InstructorCardBadges = ({ instructorId }: BadgesProps) => {
  const [badges, setBadges] = React.useState<Badge[] | null>(null)

  React.useEffect(() => {
    const abortController = new AbortController()
    const { signal } = abortController

    // Call API since this component is used on static pages.
    makeApiCall(`${apiConfig.instructorBadges(instructorId)}`, {
      method: "GET",
      signal,
    })
      .then((res) => setBadges(res?.badges))
      .catch(() => setBadges(null))

    return () => {
      abortController.abort()
    }
  }, [instructorId])

  if (!badges || badges.length === 0) return null

  return (
    <Grid container style={{ marginTop: 20 }}>
      {badges.map((badge: Badge) => (
        <Grid
          item
          key={badge.title}
          style={{ textAlign: "center", maxWidth: 70 }}
        >
          <div className="badge blue">
            <div className="circle">{iconFromString(badge.icon)}</div>
          </div>
          <div className="ribbon">{badge.title}</div>
        </Grid>
      ))}
    </Grid>
  )
}

export default InstructorCardBadges
